import {
  FormControl,
  FormHelperText,
  FormLabel,
  Skeleton,
  InputProps,
} from '@mui/joy'
import { ParseKeys } from 'i18next'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParserI18nMessage } from '~/shared/lib/i18n'
import { Input } from '../ui/styled'

type TextInputProps = {
  label?: ParseKeys
  placeholder?: ParseKeys
  name: string
  skeletonShow?: boolean
} & Omit<InputProps, 'name' | 'slotProps' | 'placeholder'>

export function TextInput({
  label,
  placeholder,
  name,
  skeletonShow,
  ...inputProps
}: TextInputProps) {
  const { t } = useTranslation()
  const { parserI18nMessage } = useParserI18nMessage()

  return (
    <Controller
      name={name}
      defaultValue=''
      render={({ field, fieldState: { error, invalid } }) => (
        <FormControl error={invalid}>
          {label && <FormLabel>{t(label as ParseKeys)}</FormLabel>}
          <Input
            fullWidth
            size='lg'
            {...inputProps}
            {...field}
            {...(placeholder
              ? { placeholder: t(placeholder as ParseKeys) }
              : {})}
            error={invalid}
            value={field.value || ''}
            slotProps={{
              ...(skeletonShow ? { root: { component: Skeleton } } : {}),
            }}
          />
          {invalid && (
            <FormHelperText
              data-testid={`error-message-${label && t(label as ParseKeys)}`}
            >
              {parserI18nMessage(error?.message)}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}
